import { Box, Text } from "@chakra-ui/react";
import BorrowersCreatedCount from "components/widgets/BorrowersCreatedCount";
import LoansCreatedCount from "components/widgets/LoansCreatedCount";
import LoanStatusCount from "components/widgets/LoanStatusCount";
import LoanTargetCount from "components/widgets/LoanTargetCount";
import OriginationsProgress from "components/widgets/OriginationsProgress";

const Widget = ({ widget }: { widget: any }) => {
  if (widget.type === "loan_status_count") {
    return <LoanStatusCount widget={widget} />;
  }
  if (widget.type === "loan_target_count") {
    return <LoanTargetCount />;
  }
  if (widget.type === "originations_progress") {
    return <OriginationsProgress />;
  }
  if (widget.type === "loans_created_count") {
    return <LoansCreatedCount />;
  }
  if (widget.type === "borrowers_created_count") {
    return <BorrowersCreatedCount />;
  }
  return (
    <Box>
      <Text>No widget found for type: {widget.type}</Text>
    </Box>
  );
};

export default Widget;
